import React from "react"
import { connect } from "react-redux"
import qs from "query-string"
import theme from "buoy-theme"
import UniversalNav from "buoy-universal-nav"
import { logout } from "../auth/actions"
import { IS_PRODUCTION, SITE_URL, STATIC_URL } from "../common/constants"
import Banner from "./components/Banner"
import startLanguage from "../integration/startLanguage"
import { inIframe } from "../common/common"
import { ThemeProvider } from "styled-components"
import { showCovid19AlertBanner, setLocale } from "../redux/actions"

class Nav extends React.Component {
  getBanner = () => {
    const { custom } = this.props
    if (custom && custom.opener) {
      return custom.opener
    } else if (custom && custom.symptom) {
      return `Let's figure out your ${custom.symptom}.`
    } else {
      return startLanguage
    }
  }

  getMessage = () => {
    // removed screener code, not sure if this is needed anymore
    let message = null
    return message
  }

  onAlertClose = () => {
    this.props.onAlertClose(false)
  }

  render() {
    const {
      chatItems,
      hasResponse,
      loggedIn,
      logout,
      brand,
      showCovid19AlertBanner,
      simpleFlowDiagnosis,
      integration,
      setLocale,
      locale,
    } = this.props

    let hideNav = inIframe() // update to detect an attribute in brand.visit_header.settings for bazaar
    if (hideNav) return null

    let topNavBanner = this.getBanner()
    let showTopNavBanner = false
    let showTopNavMessage = false
    let topNavMessage = this.getMessage()

    const symptomTest = qs.parse(window.location.search).symptom_test
    // Detect Symptom Checker Page
    if (window.location.pathname === "/symptom-checker/") {
      if (symptomTest ? chatItems.length <= 2 : !hasResponse) {
        showTopNavBanner = true
      } else {
        showTopNavMessage = true
        showTopNavBanner = false
      }
    }

    let legalLinks = []
    let sideMainLinks = []

    if (
      brand &&
      brand.side_bar_navigation &&
      brand.side_bar_navigation.settings
    ) {
      const settings = brand.side_bar_navigation.settings
      Object.keys(settings).forEach(settingName => {
        if (settingName.indexOf("legal_") !== -1) {
          legalLinks.push({ use: settings[settingName], type: "link" })
        } else if (settingName.indexOf("main_") !== -1) {
          sideMainLinks.push({ use: settings[settingName], type: "link" })
        }
      })
    }

    let topNavLinks = []
    if (brand && brand.visit_header && brand.visit_header.settings) {
      const settings = brand.visit_header.settings
      Object.keys(settings).forEach(settingName => {
        if (settingName.indexOf("main_") !== -1) {
          topNavLinks.push({ use: settings[settingName], type: "link" })
        }
      })
    }

    let logoImageSrc = null
    let secondaryLogoSrc = null
    if (brand && brand.visit_header && brand.visit_header.images) {
      if (brand.visit_header.images.hasOwnProperty("logo")) {
        logoImageSrc =
          SITE_URL + STATIC_URL + brand.visit_header.images.logo.image_src
      }
      if (brand.visit_header.images.hasOwnProperty("secondary_logo")) {
        secondaryLogoSrc =
          SITE_URL +
          STATIC_URL +
          brand.visit_header.images.secondary_logo.image_src
      }
    }

    const actions = { logout }
    const visitHeaderColors =
      brand && brand.visit_header && brand.visit_header.colors
        ? brand.visit_header.colors
        : {}
    const sideBarColors =
      brand && brand.side_bar_navigation && brand.side_bar_navigation.colors
        ? brand.side_bar_navigation.colors
        : {}
    const topNavColor = visitHeaderColors.primary
      ? brand.visit_header.colors.primary.value
      : null
    const topNavLinkColor = visitHeaderColors.secondary
      ? brand.visit_header.colors.secondary.value
      : null
    const menuIconColor = sideBarColors.tertiary
      ? sideBarColors.tertiary.value
      : null
    const sideMenuColor = sideBarColors.primary
      ? sideBarColors.primary.value
      : null

    let brandName = brand ? brand.name : null

    // This will prevent the COVID-19 banner from showing on client subdomains
    const subdomainBrands = {
      bannerhealth: "bannerhealth",
      bch: "bch",
      fhstaff: "fhstaff",
      froedtert: "froedtert",
      rcw: "rcw",
      houstonmethodist: "houstonmethodist",
      hphc: "hphc",
      "hphc-hpl": "hphc-hpl",
      nyt: "nyt",
    }

    const showAlertBanner = brandName && !subdomainBrands[brandName]

    let sideMenuLegalLinks =
      legalLinks.length > 0
        ? [legalLinks, [{ type: "text", text: "© 2019 Buoy Health, Inc." }]]
        : null
    if (sideMainLinks.length === 0) sideMainLinks = null
    if (topNavLinks.length === 0) topNavLinks = null

    const finalLocale = localStorage.getItem("locale") || locale

    // only show language selection for MA nav config
    // massachusetts is name in nav config - can change later
    if (integration.configuredExperience === "ma_covid") brandName = "massachusetts"
    let isConfiguredExperience
    if (integration.configuredExperience && !subdomainBrands[brandName]) isConfiguredExperience = true

    let nav = (
      <React.Fragment>
        <UniversalNav
          baseUrl={SITE_URL}
          brand={brandName}
          prod={IS_PRODUCTION}
          loggedIn={loggedIn}
          showTopNavMessage={showTopNavMessage}
          topNavMessage={topNavMessage}
          actions={actions}
          topNavColor={topNavColor}
          menuIconColor={menuIconColor}
          sideMenuColor={sideMenuColor}
          topNavLinkColor={topNavLinkColor}
          sideMenuLegalLinks={sideMenuLegalLinks}
          sideMenuLinks={sideMainLinks}
          topNavLinks={topNavLinks}
          logoImageSrc={logoImageSrc}
          secondaryLogoSrc={secondaryLogoSrc}
          alertVariant={"covid19"}
          onAlertClose={this.onAlertClose}
          showAlertBanner={showAlertBanner}
          languageOnChange={setLocale}
          selectedLanguage={finalLocale}
          isConfiguredExperience={isConfiguredExperience}
        />
        <Banner
          startLanguage={topNavBanner}
          show={showTopNavBanner}
          forCovid19={showCovid19AlertBanner}
          simpleFlowDiagnosis={simpleFlowDiagnosis}
        />
      </React.Fragment>
    )

    if (window.location && window.location.pathname.includes("/dashboard")) {
      nav = <ThemeProvider theme={theme}>{nav}</ThemeProvider>
    }

    return nav
  }
}


const mapStateToProps = (state, props) => ({
  loggedIn: state.auth.status.login.status === "ok" && !state.auth.isAnonymous,
  chatItems: state.chatList.items,
  custom: state.custom,
  brand: state.brand ? state.brand : undefined,
  hasResponse: state.chatList.items.findIndex(i => i.type === "response") > -1,
  showCovid19AlertBanner: state.showCovid19AlertBanner,
  simpleFlowDiagnosis: state.simpleFlow.diagnosis,
  integration: state.integration,
  locale: state.selectedLocale && state.selectedLocale.value
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  onAlertClose: show => dispatch(showCovid19AlertBanner(show)),
  setLocale: lang => dispatch(setLocale(lang)),
})
const NavWrapper = connect(mapStateToProps, mapDispatchToProps)(Nav)

export { NavWrapper as default, Nav }



// WEBPACK FOOTER //
// ./assets/nav/index.js